import { getPinia } from '@/createPiniaSingleton';
import { useReportFiltersStore } from '@/stores/reports/useReportFiltersStore';
import ReportFilterTiles from '../components/ReportFilterTiles.vue';
import { mountReportVue, withReportFilterPanelFeature } from './reportFilterPanelHost';

/**
 * Print-only filter summary. `ReportFilterTiles` with the `reportFilterPanel` feature,
 * the legacy template without it. Legacy path goes with sc-48496.
 */
angular.module('leanlaw').directive('filterTiles', ['$injector', '$compile', '$filter', 'messageBus', 'lists', 'userService', 'leanLawAuth', function ($injector, $compile, $filter, messageBus, lists, userService, leanLawAuth) {
  function linkLegacy($scope) {
    const billedOptions = lists.billedOptions;
    $scope.getDateRange = function () {
      if (!$scope.filter) return;
      if ($scope.filter.range && $scope.filter.range.label == 'All Time') return 'All Time';
      function formatDate(date) {
        return $filter('dateStandard')(new Date(date));
      }
      if (!$scope.filter.filter) return '';
      return formatDate($scope.filter.filter.range.startDate) + ' - ' + formatDate($scope.filter.filter.range.endDate);
    };
    $scope.getBilledStatus = function () {
      if (!$scope.filter) return '';
      const billed = $scope.filter.billedFilter?.id;
      return billedOptions.find(option => option.id === billed)?.label;
    };
    $scope.$on('commonFilterService-statechanged', (event, payload) => {
      $scope.filter = payload;
    });
    // MessageBus is used here so that the commonFilter module can pick it up once it loads
    messageBus.addMessage('filterDependency-ready', true);
  }
  function linkVue($scope, element) {
    const store = useReportFiltersStore(getPinia());
    $scope.$watch('printFilterTime', printFilterTime => store.configurePanel({
      printFilterTime: printFilterTime || null
    }));
    mountReportVue(ReportFilterTiles, $scope, element, $injector);
  }
  return {
    restrict: 'E',
    scope: {
      printFilterTime: '='
    },
    link($scope, element) {
      let alive = true;
      $scope.$on('$destroy', () => {
        alive = false;
      });
      withReportFilterPanelFeature(userService, leanLawAuth.features, () => alive, enabled => {
        if (enabled) {
          linkVue($scope, element);
          return;
        }
        element.html(require('./views/filterTiles.html'));
        $compile(element.contents())($scope);
        linkLegacy($scope);
        $scope.$applyAsync();
      });
    }
  };
}]);